<template>
  <div
    class="tab-pane"
    v-show="active"
    :id="id || label"
    :class="{ active: active }"
    :aria-expanded="active"
  >
    <slot v-if="!lazy || loaded"></slot>
  </div>
</template>
<script>
export default {
  name: 'tab-pane',
  props: {
    label: null,
    id: null,
    lazy: Boolean
  },
  inject: ['addTab', 'removeTab'],
  data() {
    return {
      active: false,
      loaded: false
    };
  },
  watch: {
    active: {
      immediate: true,
      handler(value) {
        if (value) this.loaded = true;
      }
    }
  },
  mounted() {
    this.addTab(this);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeTab(this);
  }
};
</script>
<style></style>
